import React from "react";
import Svg, { Polyline } from "svgs";

export default function ChevronDown(props){
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <Polyline points="6 9 12 15 18 9" />
    </Svg>
  )
}
